import { createUseStyles, withTheme } from '@glu/theming';
import locale from '@glu/locale';
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, PRIMARY, SMALL } from '@glu/buttons-react';
import styles from './Actions.styles';
import { useDropdownContext } from './DropdownContext';

const useStyles = createUseStyles(styles);

const Actions = ({
  applyButtonClasses,
  buttonClasses,
  cancelButtonClasses,
  dataQa,
  disabled,
  onClickApply,
  onClickCancel,
  ...rest
}) => {
  const { focusOn } = useDropdownContext();
  const classes = useStyles(rest);
  const applyRef = useRef();
  const cancelRef = useRef();

  useEffect(() => {
    if (focusOn === 'buttons') {
      if (disabled) {
        cancelRef.current?.focus();
      } else {
        applyRef.current?.focus();
      }
    }
  }, [focusOn, disabled]);

  return (
    <div className={`${classes.actions} ${buttonClasses}`}>
      <Button
        className={applyButtonClasses}
        data-qa={dataQa ? `${dataQa}-apply-button` : 'apply-button'}
        disabled={disabled}
        innerRef={applyRef}
        onClick={onClickApply}
        size={SMALL}
        text={locale.get('apply')}
        type="button"
        variant={PRIMARY}
      />
      <button
        ref={cancelRef}
        className={`${classes.cancelButton} ${cancelButtonClasses}`}
        data-qa={dataQa ? `${dataQa}-cancel-button` : 'cancel-button'}
        onClick={onClickCancel}
        type="button"
      >
        {locale.get('cancel')}
      </button>
    </div>
  );
};

Actions.propTypes = {
  applyButtonClasses: PropTypes.string.isRequired,
  buttonClasses: PropTypes.string.isRequired,
  cancelButtonClasses: PropTypes.string.isRequired,
  dataQa: PropTypes.string,
  disabled: PropTypes.bool,
  onClickApply: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  options: PropTypes.shape({}),
};

Actions.defaultProps = {
  dataQa: '',
  disabled: false,
  options: {},
};

export default withTheme(Actions);
